import React, { useEffect, useRef, useState } from 'react';
import './Constitution.css';

function getHeaderOffset() {
  const header = document.querySelector('header');

  if (!header) {
    return 24;
  }

  const headerStyles = window.getComputedStyle(header);

  if (headerStyles.position !== 'fixed') {
    return 24;
  }

  return Math.ceil(header.getBoundingClientRect().height) + 16;
}

function Constitution() {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const targetRef1 = useRef(null);
  const targetRef2 = useRef(null);
  const targetRef3 = useRef(null);
  const targetRef4 = useRef(null);
  const targetRef5 = useRef(null);
  const targetRef6 = useRef(null);
  const targetRef7 = useRef(null);
  const targetRef8 = useRef(null);

  const constitutionSections = [
    { ref: targetRef1, label: 'I. Name' },
    { ref: targetRef2, label: 'II. Registered Office' },
    { ref: targetRef3, label: 'III. Objects' },
    { ref: targetRef4, label: 'IV. Powers' },
    { ref: targetRef5, label: 'V. Income and Property' },
    { ref: targetRef6, label: 'VI. Liability' },
    { ref: targetRef7, label: 'VII. Member Contribution' },
    { ref: targetRef8, label: 'VIII. Dissolution' },
  ];

  const scrollToTarget = (targetRef) => {
    if (targetRef?.current) {
      const offset = targetRef.current.offsetTop - getHeaderOffset();

      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 420);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <section className='constitution-page'>
      <div className='constitution-hero'>
        <p className='constitution-eyebrow'>Governing Document</p>
        <h1>
          THE COMPANIES (NORTHERN IRELAND) ORDERS 1986 TO 1990
          <br />
          COMPANY LIMITED BY GUARANTEE
          <br />
          AND NOT HAVING A SHARE CAPITAL
          <br />
          MEMORANDUM OF ASSOCIATION
          <br />
          OF
          <br />
          Chinese Language School NI
        </h1>
      </div>

      <div className='constitution-layout'>
        <aside className='constitution-sidebar'>
          <div className='constitution-sidebar-card'>
            <h2>Quick Navigation</h2>
            <nav aria-label='Constitution sections'>
              <ol>
                {constitutionSections.map((section) => (
                  <li key={section.label}>
                    <button onClick={() => scrollToTarget(section.ref)}>
                      {section.label}
                    </button>
                  </li>
                ))}
              </ol>
            </nav>
          </div>
        </aside>

        <div className='constitution-content'>
          <article
            ref={targetRef1}
            id='constitution-name'
            className='constitution-section-card'>
            <h2>I. NAME</h2>
            <p>
              The name of the Company is Chinese Language School NI (&apos;the
              Company&apos;).
            </p>
          </article>

          <article
            ref={targetRef2}
            id='constitution-office'
            className='constitution-section-card'>
            <h2>II. REGISTERED OFFICE</h2>
            <p>
              The Company&apos;s registered office is to be situated in Northern
              Ireland.
            </p>
          </article>

          <article
            ref={targetRef3}
            id='constitution-objects'
            className='constitution-section-card'>
            <h2>III. OBJECTS</h2>
            <p>
              The Company is established to promote the education of the
              inhabitants of the Greater Belfast area and its environs of
              Northern Ireland (hereinafter called the &quot;area of
              benefit&quot;), by associating the statutory authorities,
              community and voluntary organisations and the inhabitants, with
              the object of improving the conditions of life for the said
              inhabitants and in particular:
            </p>
            <ol>
              <li>
                To advance and provide a focus on Chinese language (in
                particular Cantonese &amp; Mandarin) among the general public,
                especially children, by promoting awareness of, the study of,
                and research into the history, folklore, skills, arts, crafts
                and cultural heritage of China;
              </li>
              <li>
                To promote the education of people, and their children, through
                the provision of Chinese language resources;
              </li>
              <li>
                To advance education among parents in the area of benefit and to
                encourage parents in the area of benefit to provide mutual
                support and encouragement to each other and to their children.
              </li>
            </ol>
          </article>

          <article
            ref={targetRef4}
            id='constitution-powers'
            className='constitution-section-card'>
            <h2>IV. POWERS</h2>
            <p>
              The Company has the following powers which may be exercised only
              in promoting the objects:
            </p>
            <ol>
              <li>
                Provide or secure the provision of educational and recreational
                facilities for the benefit of the general public in the area of
                benefit;
              </li>
              <li>
                Provide, endow, furnish and fit out with all necessary furniture
                and other equipment, and maintain such buildings, premises and
                centres as may from time to time be required for the purposes of
                the Company;
              </li>
              <li>
                Co-operate and enter into arrangements with any authorities,
                national, local or otherwise;
              </li>
              <li>
                Bring together in conference representatives of voluntary
                organisations, Government Departments, statutory authorities and
                individuals;
              </li>
              <li>
                Arrange and provide for, either alone or with others, the
                holding of exhibitions, meetings, outings, lectures, classes,
                seminars or training courses;
              </li>
              <li>
                Collect and disseminate information on all matters relating to
                its objects, and to exchange such information with other bodies
                having similar objects whether in the United Kingdom or
                elsewhere;
              </li>
              <li>
                Write, print or publish, in whatever form, such papers, books,
                periodicals, pamphlets or other documents, including films and
                recorded material, as shall further its objects, and to issue or
                circulate the same whether for payment or otherwise;
              </li>
              <li>
                Accept subscriptions, donations, devises and bequests of and to
                purchase, take on lease or in exchange, hire or otherwise
                acquire and hold any real or personal estate, maintain and alter
                any of the same as are necessary for any of the objects of the
                Company and (subject to such consents as may be required by law)
                sell, ease or otherwise dispose of or mortgage any such real or
                personal estate, having due regard to the requirements of, or
                conditions established by, statutory authorities or bodies
                providing funds or assistance of any kind to the Company;
              </li>
              <li>
                Issue appeals, hold public meetings and take such other steps as
                may be required for the purpose of procuring contributions to
                the funds of the Company in the form of donations, subscriptions
                or otherwise PROVIDED that the Company shall not undertake any
                permanent trading activity;
              </li>
              <li>
                Draw, make, accept, endorse, discount, execute and issue
                promissory notes, bills, cheques and other instruments, and to
                operate bank accounts;
              </li>
              <li>
                Borrow or raise money for the objects of the Company on such
                terms and (with such consents as are required by law) on such
                security as may be thought fit;
              </li>
              <li>
                Take and accept any gift of money, property or other assets,
                whether subject to any special trust or not, for any one or more
                of the objects of the Company;
              </li>
              <li>
                Invest the moneys of the Company not immediately required for
                its objects in or upon such investments, securities or property
                as may be thought fit, subject nevertheless to such conditions
                (if any) and such consents (if any) as may for the time being be
                imposed or required by law and subject also as hereinafter
                provided;
              </li>
              <li>
                Make any charitable donation either in cash or assets for the
                furtherance of the objects of the Company.
              </li>
              <li>
                Establish and support any charitable association or body and to
                subscribe or guarantee money for charitable purposes calculated
                to further the objects of the Company;
              </li>
              <li>
                Make regulations for the proper supervision, control and
                management of any property which may be so acquired;
              </li>
              <li>
                Employ and remunerate such staff, who shall NOT be members of
                the Education Committee of the Company, as are necessary for the
                proper pursuit of the objects of the Company;
              </li>
              <li>
                Insure and arrange insurance cover for and to indemnify its
                officers, servants and voluntary workers from and against all
                such risks incurred in the course of the performance of their
                duties as may be thought fit;
              </li>
              <li>
                Amalgamate with any companies, institutions, societies or
                associations which are charitable at law and have objects
                altogether or mainly similar to those of the Company and
                prohibit the payment of any dividend or profit to and the
                distribution of any of their assets amongst their members at
                least to the same extent as such payments or distributions are
                prohibited in the case of members of the Company by this
                Memorandum of Association;
              </li>
              <li>
                Pay out of the funds of the Company the costs, charges and
                expenses of and incidental to the formation and registration of
                the Company;
              </li>
              <li>
                Do all such other lawful things as shall further the above
                objects or any of them.
              </li>
            </ol>
            <div className='constitution-note'>
              <h3>Provided that:</h3>
              <ol>
                <li>
                  In case the Company shall take or hold any property which may
                  be subject to any trusts, the Company shall only deal with or
                  invest the same in such manner as allowed by law, having
                  regard to such trusts;
                </li>
                <li>
                  The objects of the Company shall not extend to the regulation
                  of relations between workers and employers or organisations of
                  workers and organisations of employers.
                </li>
              </ol>
            </div>
          </article>

          <article
            ref={targetRef5}
            id='constitution-income'
            className='constitution-section-card'>
            <h2>V. INCOME AND PROPERTY</h2>
            <p>
              The income and property of the Company shall be applied solely
              towards the promotion of its objects as set forth in the
              Memorandum of Association and no portion thereof shall be paid or
              transferred, directly or indirectly, by way of dividend, bonus or
              otherwise howsoever by way of profit, to members or Directors of
              the Company.
            </p>
            <p>
              Provided that nothing herein shall prevent any payment in good
              faith by the Company:
            </p>
            <ol>
              <li>
                Of reasonable and proper remuneration for any services rendered
                to the Company by any member, officer or servant of the Company
                who is not a Director of the Company;
              </li>
              <li>
                Of interest on money lent by any member of the Company or of its
                Board of Directors at a rate per annum not exceeding 2% less
                than the minimum lending rate prescribed for the time being by a
                clearing bank selected by that Board of Directors or 3%,
                whichever is the greater;
              </li>
              <li>
                Of reasonable and proper rent for premises demised or let by any
                member of the Company or of its Board of Directors;
              </li>
              <li>
                Of fees, remuneration or other benefit in money or money&apos;s
                worth to a Company of which a member of the Board of Directors
                may be a member holding not more than one hundredth part of the
                capital of that Company;
              </li>
              <li>
                To any member of its Board of Directors of reasonable and proper
                out of pocket expenses.
              </li>
            </ol>
          </article>

          <article
            ref={targetRef6}
            id='constitution-liability'
            className='constitution-section-card'>
            <h2>VI. LIABILITY</h2>
            <p>The liability of the members is limited.</p>
          </article>

          <article
            ref={targetRef7}
            id='constitution-contribution'
            className='constitution-section-card'>
            <h2>VII. MEMBER CONTRIBUTION</h2>
            <p>
              Every member of the Company undertakes to contribute to the assets
              of the Company, in the event of the same being wound up while it
              is a member, or within one year after it ceases to be a member,
              for payment of the debts and liabilities of the Company contracted
              before it ceases to be a member, and of the costs, charges and
              expenses of winding up, and for the adjustment of the rights of
              the contributories among themselves, such amount as may be
              required not exceeding {'\u00A3'}1.
            </p>
          </article>

          <article
            ref={targetRef8}
            id='constitution-dissolution'
            className='constitution-section-card'>
            <h2>VIII. DISSOLUTION</h2>
            <p>
              If upon the winding-up or dissolution of the Company there
              remains, after the satisfaction of all its debts and liabilities,
              any property whatsoever, the same shall not be paid to or
              distributed among the members of the Company, but shall be given
              or transferred to some other charitable institution or
              institutions having objects similar to the objects of the Company,
              whose activities are carried out within the area of benefit, and
              which shall prohibit the distribution of its or their income and
              property to an extent at least as great as is imposed on the
              Company under or by virtue of Clause 5 hereof, such institution or
              institutions to be determined by the members of the Company at or
              before the time of dissolution, and in so far as effect cannot be
              given to such provision, then to some other charitable object.
            </p>
          </article>
        </div>
      </div>

      <button
        type='button'
        className={`constitution-back-to-top ${
          showBackToTop ? 'is-visible' : ''
        }`}
        onClick={scrollToTop}
        aria-label='Back to top'>
        <span aria-hidden='true'>↑</span>
        <span>Top</span>
      </button>
    </section>
  );
}

export default Constitution;
